import { useCallback } from 'react';
import { useBranches } from '../../../../state/Branches/hooks/useBranches';
import { NameInput } from 'sections/onsite-campaigns/pages/CampaignEditor/components/NameInput';
import { useTranslation } from 'react-i18next';

export interface BranchNameFieldProps {
  id: string;
  name: string;
}

export const BranchNameField = ({ id, name }: BranchNameFieldProps) => {
  const { t } = useTranslation('campaigns');

  const { updateBranch } = useBranches();

  const onChange = useCallback(
    updatedName => {
      updateBranch(id, updatedName);
    },
    [id, updateBranch],
  );

  return (
    <NameInput
      title={t('onsite.editor.workflow.nameInput.branchTitle')}
      name={name}
      onChange={onChange}
      aria-label={t('onsite.editor.workflow.branchControls.branchName')}
      tooltip={{
        title: t('onsite.editor.workflow.nameInput.tooltipTitle'),
        content: t('onsite.editor.workflow.nameInput.tooltipContent'),
      }}
    />
  );
};
